import { useState } from "react";
import "./admin.css";

const Admin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        setError("");
        setLoading(true);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    username,
                    password
                })
            });

            const data = await res.json();

            if (!res.ok || !data.success) {
                setError(data.error || "Accesso negato");
                return;
            }
            localStorage.setItem("adminToken", data.token);
            window.location.href = "/admin/dashboard";

        } catch (err) {
            console.error(err);
            setError("Errore di connessione");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-page">
            <div className="admin-container">
                <h1 className="admin-title">Login Admin</h1>

                <div className="admin-form">
                    <input
                        className="admin-input"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <input
                        className="admin-input"
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                        className="admin-button"
                        type="button"
                        onClick={handleLogin}
                    >
                        {loading ? "Accesso..." : "Accedi"}
                    </button>
                </div>

                {error && <div className="admin-error">{error}</div>}
            </div>
        </div>
    );
};

export default Admin;